import { InformationCircleIcon } from '@hugeicons/core-free-icons';
import { HugeiconsIcon } from '@hugeicons/react-native';
import type { ButtonProps, WithResponsive } from '@sunrise-ui/primitives';
import { Button, Colors, useDynamicStyles } from '@sunrise-ui/primitives';
import React from 'react';
import { StyleSheet, View } from 'react-native';

export function CardInfoButton(props: Omit<ButtonProps, 'children'>) {
  const styles = useDynamicStyles(createStyles);

  return (
    <View style={styles.container}>
      <Button
        style={styles.button}
        contentStyle={styles.buttonContent}
        {...props}
      >
        {''}
      </Button>
      <View style={styles.iconContainer}>
        <HugeiconsIcon
          icon={InformationCircleIcon}
          size={20}
          color={Colors.text}
        />
      </View>
    </View>
  );
}

const createStyles = ({ isMobile }: WithResponsive) =>
  StyleSheet.create({
    container: {
      position: 'absolute',
      bottom: 0,
      right: 0,
      width: 60,
      height: 60,
    },
    button: {
      position: 'absolute',
      bottom: -5,
      right: isMobile ? -50 : -40,
      width: 108,
      transform: [{ rotate: '-50deg' }],
      borderBottomRightRadius: 20,
      borderRadius: 0,
    },
    buttonContent: {
      borderRadius: 0,
    },
    iconContainer: {
      position: 'absolute',
      bottom: isMobile ? 6 : 10,
      right: isMobile ? 6 : 10,
      pointerEvents: 'none',
    },
  });
